<template>
  <svg :id="id" x="0px" y="0px" width="520px" height="520" viewBox="-21.5 -36.5 300 520"
       enable-background="new -21.5 -36.5 300 520" xml:space="preserve">
		<path id="Padlock-Joint" :fill="themeObj.strokeColor"
          d="M127.973,8.377c-57.79,0-104.806,46.856-104.806,104.449v86.339h6.964v-86.339c0-53.767,43.892-97.509,97.842-97.509c53.95,0,97.843,43.742,97.843,97.509v38.812h-22.344v-38.812c0-41.488-33.869-75.24-75.5-75.24c-41.629,0-75.497,33.753-75.497,75.24v86.339h6.964v-86.339c0-37.66,30.744-68.3,68.533-68.3c37.792,0,68.536,30.64,68.536,68.3v45.776h36.271v-45.776C232.779,55.233,185.764,8.377,127.973,8.377z"/>
    <g id="Padlock-Body">
			<rect x="7.155" y="157.706" fill="#FFFFFF" width="241.636" height="176.515"/>

      <polygon id="Padlock-Body-Line-Left-1" :fill="themeObj.strokeColor2"
               points="0.525,219.199 42.775,219.199 42.775,214.508 0.525,214.508"/>
      <polygon id="Padlock-Body-Line-Left-2" :fill="themeObj.strokeColor2"
               points="0.525,248.314 42.775,248.314 42.775,243.625 0.525,243.625"/>
      <polygon id="Padlock-Body-Line-Left-3" :fill="themeObj.strokeColor2"
               points="0.525,277.432 42.775,277.432 42.775,272.741 0.525,272.741"/>

      <polygon id="Padlock-Body-Line-Right-1" :fill="themeObj.strokeColor2"
               points="255.245,214.508 212.996,214.508 212.996,219.198 255.245,219.198"/>
      <polygon id="Padlock-Body-Line-Right-2" :fill="themeObj.strokeColor2"
               points="255.245,243.624 212.996,243.624 212.996,248.314 255.245,248.314"/>
      <polygon id="Padlock-Body-Line-Right-3" :fill="themeObj.strokeColor2"
               points="255.245,272.74 212.996,272.74 212.996,277.432 255.245,277.432"/>

      <path :fill="themeObj.strokeColor"
            d="M0.113,150.669v190.586h255.719V150.669H0.113z M248.791,334.221H7.155V157.706h241.636V334.221z"/>

      <polygon id="Padlock-Body-Line-Key" :fill="themeObj.strokeColor2"
               points="125.516,271.631 131.254,271.631 131.254,220.034 125.516,220.034"/>

      <g id="Padlock-Body-Center">
				<path id="Padlock-Body-Circle" fill="none" :stroke="themeObj.strokeColor2" stroke-width="7.395"
              d="M128.409,187.176c-32.393,0.014-58.667,26.286-58.679,58.68c-0.013,32.396,26.237,58.646,58.632,58.633s58.667-26.285,58.679-58.68C187.055,213.414,160.804,187.164,128.409,187.176z"/>
        <path id="Padlock-Body-Circle-Progress" fill="none" stroke="#E4030B" stroke-width="7.395"
              d="M128.409,187.176c-32.393,0.014-58.667,26.286-58.679,58.68c-0.013,32.396,26.237,58.646,58.632,58.633s58.667-26.285,58.679-58.68C187.055,213.414,160.804,187.164,128.409,187.176z"/>
			</g>
		</g>

    <g v-if="showQuestionsLabel" id="Padlock-Content" class="padlock-content" transform="translate(20 450)">
			<text id="Padlock-Content-Steps" class="steps" dx="-44" y="0">{{ passedQuestions }}/{{ totalQuestions }}</text>
      <text id="Padlock-Content-Label" dx="120" y="-48" class="label">
				<tspan>{{ labelSplit[0] }}</tspan>
        <tspan v-if="labelSplit[1]" x="120" dy="30">{{ labelSplit[1] }}</tspan>
			</text>
      <rect x="120" y="0" width="90" height="3" class="line" :fill="themeObj.strokeColor2"></rect>
		</g>

    <g v-if="hintText" width="350" height="200" class="padlock-content" transform="translate(-50 350)">
      <foreignObject width="350" height="200">
        <p class="hint" xmlns="http://www.w3.org/1999/xhtml">{{ hintText }}</p>
      </foreignObject>
    </g>

	</svg>
</template>

<script>
  import {TweenMax, TimelineMax} from 'gsap'
  import * as d3 from "d3";

  export default {
    name: 'SvgPadlockSteps',
    props: {
      id: {
        type: [Number, String],
        default: 'Padlock'
      },
      totalQuestions: {
        type: [Number, String],
        default: 4
      },
      passedQuestions: {
        type: [Number, String],
        default: 0
      },
      minCorrectReplies: {
        type: [Number, String],
        default: 2
      },
      theme: {
        type: String,
        default: 'light'
      },
      pause: {
        type: [String, Boolean],
        default: false
      },
      label: {
        type: String,
  //				default: null,
        default: 'poprawnych <br>odpowiedzi'
      },
      showQuestionsLabel: {
         type: Boolean,
         default: true
      },
      hintText: {
        type: String,
        default: null
      }
    },
    data: () => ({
      tl: null,
      padlock: null,
      padlockJoint: null,
      padlockBody: null,
      padlockBodyKey: null,
      padlockProgress: null,
      opened: false,
      openedDistance: 24,
      animateComplete: false,
      animated: false,
    }),
    computed: {
      total() {
        return this.totalQuestions
      },
      passed() {
        return Math.min(this.total, this.passedQuestions)
      },
      steps() {
        return (this.padlockProgress.getTotalLength() / this.total) * (this.total - this.passed);
      },
      themeObj() {
        let obj = {
          strokeColor: '#D6D6D6',
          strokeColor2: '#bebebe',
          textColor: "#E4030B"
        };
        //
        switch (this.theme) {
          case 'light':
            // default
            break;
          case 'dark':
            obj = {
              strokeColor: '#000000',
              strokeColor2: '#bebebe',
              textColor: "#000000"
            };
            break;
        }

        return obj;
      },
      labelSplit() {
        return this.label.split('<br>')
      }
    },
    watch: {
      passedQuestions() {
        if (this.animateComplete && this.padlockProgress) {
          new TweenMax.to(this.padlockProgress, 1.75, {strokeDashoffset: this.steps, ease: Power3.easeOut});
        }
      },
      opened() {
        if (this.opened == true) {
          // open
          this.openPadlock();
        } else {
          // close
          this.closePadlock();
        }
      }
    },
    methods: {
      animateCompleteHandler() {
        this.animateComplete = true;
        this.opened = Boolean(this.passed >= this.minCorrectReplies);
        //only for test simulate
        /*this.$el.addEventListener('click', (e) => {
            e.preventDefault();
            this.togglePadlock();
        })*/
      },
      closePadlock(delay = 0) {
        new TweenMax.to(this.padlockJoint, .45, {y: 0, delay: delay, ease: Power2.easeInOut});
        new TweenMax.to(this.padlockBody, .45, {y: 0, delay: delay, ease: Power2.easeInOut});
        new TweenMax.to(this.padlockBodyKey, .35, {
          autoAlpha: 0.4,
          rotation: 0,
          transformOrigin: "center center",
          smoothOrigin: false,
          ease: Power4.easeInOut
        });
      },
      openPadlock(delay = 0) {
        new TweenMax.to(this.padlockJoint, .65, {y: this.openedDistance * (-1), delay: delay, ease: Power2.easeInOut});
        new TweenMax.to(this.padlockBody, .65, {y: this.openedDistance / 2, delay: delay, ease: Power2.easeInOut});
        new TweenMax.to(this.padlockBodyKey, .65, {
          autoAlpha: 0.6,
          rotation: 90,
          transformOrigin: "center center",
          smoothOrigin: false,
          ease: Power4.easeInOut
        });
      },
      togglePadlock() {
        this.opened = !this.opened;
      },
      init() {
        this.padlock = this.$el;

        this.padlockJoint = this.padlock.querySelector('#Padlock-Joint');
        this.padlockBody = this.padlock.querySelector('#Padlock-Body')
      },
      createAnimate() {

        this.tl = new TimelineMax({delay: .3, paused: true, onComplete: this.animateCompleteHandler});
        this.tl.seek(0).invalidate();

        let _body_line_left_1 = this.padlock.querySelector('#Padlock-Body-Line-Left-1');
        let _body_line_left_2 = this.padlock.querySelector('#Padlock-Body-Line-Left-2');
        let _body_line_left_3 = this.padlock.querySelector('#Padlock-Body-Line-Left-3');
        let _body_line_right_1 = this.padlock.querySelector('#Padlock-Body-Line-Right-1');
        let _body_line_right_2 = this.padlock.querySelector('#Padlock-Body-Line-Right-2');
        let _body_line_right_3 = this.padlock.querySelector('#Padlock-Body-Line-Right-3');

        this.padlockBodyKey = this.padlock.querySelector('#Padlock-Body-Line-Key');

        let _body_center = this.padlock.querySelector('#Padlock-Body-Center');
        TweenMax.set(_body_center, {rotation: -45, transformOrigin: "center center", smoothOrigin: false});

        let _body_circle = this.padlock.querySelector('#Padlock-Body-Circle');
        TweenMax.set(_body_circle, {strokeDasharray: _body_circle.getTotalLength()});

        this.padlockProgress = this.padlock.querySelector('#Padlock-Body-Circle-Progress');
        TweenMax.set(this.padlockProgress, {strokeDasharray: this.padlockProgress.getTotalLength()});

        let _body_lines_left = [_body_line_left_1, _body_line_left_2, _body_line_left_3];
        let _body_lines_right = [_body_line_right_1, _body_line_right_2, _body_line_right_3];

        // --------------------------- o

        this.tl.from(this.padlock, 1, {autoAlpha: 0, y: 10, ease: Power3.easeInOut});
        //
        this.tl.fromTo(this.padlockJoint, 1.5, {y: 0}, {y: this.openedDistance * (-1) + 12, ease: Power2.easeInOut}, 0);
        this.tl.fromTo(this.padlockBody, 1.5, {y: 0}, {y: this.openedDistance / 2, ease: Power2.easeInOut}, 0);
        //
        this.tl.staggerFromTo(_body_lines_left, 1.25, {autoAlpha: 1, scaleX: 0}, {
          autoAlpha: .4,
          scaleX: 1,
          ease: Power4.easeOut
        }, .175, 1.25);
        this.tl.staggerFromTo(_body_lines_right, 1.25, {autoAlpha: 1, scaleX: 0,}, {
          autoAlpha: .4,
          scaleX: 1,
          transformOrigin: "right top",
          smoothOrigin: false,
          ease: Power4.easeOut
        }, .175, 1.25);
        //
        this.tl.fromTo(_body_circle, 1.95, {
          strokeDashoffset: _body_circle.getTotalLength(),
          autoAlpha: 0
        }, {strokeDashoffset: 0, autoAlpha: 0.3, ease: Power3.easeInOut}, '-=1.85');
        //
        this.tl.fromTo(this.padlockBodyKey, 2.75, {autoAlpha: 1, scaleY: 0}, {
          autoAlpha: 0.4,
          scaleY: 1,
          ease: Power4.easeInOut
        }, '-=.95');
        //

  //                this.tl.set(this.padlockProgress, {rotation: 45+180, transformOrigin:"center center", smoothOrigin:true}, '-=1.5');
        this.tl.fromTo(this.padlockProgress, 2.75,
          {
            autoAlpha: 0,
            strokeDashoffset: this.padlockProgress.getTotalLength(),
            transformOrigin: "center center",
            smoothOrigin: false
          },
          {
            autoAlpha: 1,
            strokeDashoffset: this.steps,
            transformOrigin: "center center",
            smoothOrigin: false,
            ease: Power4.easeInOut
          },
          '-=1.5');
        //
        this.tl.to(this.padlockJoint, 2.25, {y: 0, ease: Power2.easeInOut}, 1.5);
        this.tl.to(this.padlockBody, 2.25, {y: 0, ease: Power2.easeInOut}, 1.5);
        //
        this.tl.timeScale(1.75);
      },
      playAnimate() {
        if (this.animated == true) return;
        this.restartAnimate();
        this.animated = true;
      },
      restartAnimate() {
        this.tl.restart();
      },
      reverseAnimate() {
        this.tl.reversed() ? this.tl.play() : this.tl.reverse();
      }
    },
    mounted() {
      this.init();
      this.createAnimate();
      if (this.pause == false) {
        this.playAnimate();
      }
    },
    beforeDestroy() {
      this.reverseAnimate()
    }
  }
</script>

<style lang="scss" scoped>
  @import "src/assets/fonts/Corbert/variables";

  #Padlock {
    margin-top: -20px;
    max-height: 340px;
  }

  #PadlockSmall{
    margin-top: 0px;
    max-height: 240px;
  }

  #Spinner {
    display: block;
    margin: 0 auto;
  }

  .padlock-content {
    .steps {
      font-size: 90px;
      font-family: $corbert-font-family-bold;
      line-height: 1;
      letter-spacing: -2px;
      margin-bottom: 0;
      margin-right: 4px;
      color: #222222;
      fill: currentColor;
    }

    .label {
      font-size: 24px;
      font-family: $corbert-font-family-extrabold;
      word-wrap: normal;
    }

    .hint{
      font-size: 20px;
      font-family: $corbert-font-family-bold;
      //fill: #55565A;
      color: #a4a4a4;
    }

    .line {
      fill: #E4030B;
    }
  }
</style>
